import { menuListItems } from 'assets/menu/menuList';
import { BreadCrumb } from 'components/BreadCrumb';
import { GoToBack } from 'components/GoToBack';
import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import React, {  } from 'react';
import { useHistory } from 'react-router';
import { SellerLeadForm } from '../SellerLeadForm';

import { HeaderContainer } from './styles';
import { useSellerLeadDetails } from './useSellerLeadDetails';

export const SellerLeadDetails: React.FC = () => { 
  const {location} = useHistory(); 
  const {
    handleChangeRadioOfChecklist,
    handleInputChange,
    handleSelectChange,
    checklist,
    inputsValues,
    touched,
    errors,
    properties,
    imagePath,
    handlerImageSelected,
    socialMedias,
    handleRemoveContact,
    handleAddContact,
    changeFooter,
    showAlertForm,
    submitButton,
    changeNameTag,
    handleSubmit,
    hasError,
    isLoading,
    statusAnalysisLead,
    usersOptions,
    category,
    checkListStatus,
    showCard,
    checkListAnswered,
    loadBusinessTrust,
    setStatusToLead,
    reasonToLeadReproved,
    setReasonToLeadReproved,
    socialMediaTypes,
    contactTypes,
    initialInputsValues,
    logoIsPNG
  } = useSellerLeadDetails();

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack path="/sellers/leads"/>
          </div>

          <div className="header-text">
            <BreadCrumb itens={["Novos cadastros", String(location.state)]} itemActive={String(location.state || "Novo")} />
          </div>
        </ HeaderContainer>
      </Header>
      
      <SellerLeadForm
        logoIsPNG={logoIsPNG}
        handleChangeRadioOfChecklist={handleChangeRadioOfChecklist}
        handleChange={handleInputChange}
        checklist={checklist}
        inputsValues={inputsValues}
        initialInputsValues={initialInputsValues}
        touched={touched}
        errors={errors}
        handleSelectChange={handleSelectChange}
        properties={properties}
        imagePath={imagePath}
        handlerImageSelected={handlerImageSelected}
        socialMedias={socialMedias}
        handleRemoveContact={handleRemoveContact}
        handleAddContact={handleAddContact}
        changeFooter={changeFooter}
        handleSubmit={handleSubmit}
        showAlertForm={showAlertForm}
        submitButton={submitButton}
        changeNameTag={changeNameTag}
        hasError={hasError}
        isLoading={isLoading}
        statusAnalysisLead={statusAnalysisLead}    
        usersOptions={usersOptions}
        category={category}
        showCard={showCard}
        checkListStatus={checkListStatus}
        checklistAnswered={checkListAnswered}
        loadBusinessTrust={loadBusinessTrust}
        setStatusToLead={setStatusToLead}
        reasonToLeadReproved={reasonToLeadReproved}
        setReasonToLeadReproved={setReasonToLeadReproved}
        socialMediaTypes={socialMediaTypes}
        contactTypes={contactTypes}
      />
    </Menu>
  );
}
